module.exports = __webpack_public_path__ + "static/marco.00d1b983.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/marco.png
// module id = 573
// module chunks = 263791100135453